import { useLayoutEffect, useState } from 'react';

type UseElementHeight = (element: HTMLElement | null) => number;
export const useElementHeight: UseElementHeight = (element) => {
  const [height, setHeight] = useState<number>(0);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const newHeight = entry.contentRect.height;
        if (height !== newHeight) {
          setHeight(newHeight);
        }
      });
    });

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  });

  return height;
};
